/**
 * P0-A: Conversation Normalizer
 * Enforces safe conversation shape across all UI consumers
 */

export interface NormalizedConversation {
  id: string
  title: string
  created_at: string
  updated_at: string
  archived_at: string | null
  deleted_at: string | null
  mode: string
}

export function normalizeConversation(raw: any): NormalizedConversation {
  if (!raw || typeof raw !== "object") {
    console.warn("[v0][normalize] received invalid conversation object:", typeof raw)
    return {
      id: raw?.id || "",
      title: "Untitled",
      created_at: raw?.created_at || new Date().toISOString(),
      updated_at: raw?.updated_at || new Date().toISOString(),
      archived_at: null,
      deleted_at: null,
      mode: "advisory",
    }
  }

  return {
    id: raw.id || "",
    title: raw.title || "Untitled",
    created_at: raw.created_at || new Date().toISOString(),
    updated_at: raw.updated_at || new Date().toISOString(),
    archived_at: raw.archived_at ?? null,
    deleted_at: raw.deleted_at ?? null,
    mode: raw.mode || "advisory",
  }
}

export function normalizeConversations(rawList: any[]): NormalizedConversation[] {
  if (!Array.isArray(rawList)) {
    console.warn("[v0][normalize] received non-array conversation list:", typeof rawList)
    return []
  }

  return rawList.map(normalizeConversation)
}
